import { useState } from 'react';
import { Link } from 'react-router-dom';

const products = [
  { id: 1, slug: 'altyapi-lightbox', name: 'Altyapı Lightbox', desc: 'Standart alüminyum profil çerçeveli, tek veya çift taraflı ışıklı reklam panosu.', img: '/images/products/prod-1.webp' },
  { id: 2, slug: 'standart-lightbox', name: 'Standart Lightbox', desc: 'Her ortama uygun, dayanıklı ve ekonomik standart lightbox modelleri.', img: '/images/products/prod-2.webp' },
  { id: 3, slug: 'reklam-giydirme', name: 'Lightbox Reklam Giydirme', desc: 'Mağaza cephesi ve vitrin için özel tasarım lightbox giydirme çözümleri.', img: '/images/products/prod-3.webp' },
  { id: 4, slug: 'dolak-lightbox', name: 'Dolak Lightbox', desc: 'Zemine monte edilebilen, taşınabilir dolak tipi lightbox sistemleri.', img: '/images/products/prod-4.webp' },
  { id: 5, slug: 'kutu-harf', name: 'Kutu Harf Lightbox', desc: 'Üç boyutlu ışıklı kutu harf ve logo uygulamaları.', img: '/images/products/prod-5.webp' },
  { id: 6, slug: 'dis-mekan-lightbox', name: 'Dış Mekan Lightbox', desc: 'Hava koşullarına dayanıklı, IP65 sertifikalı dış mekan lightbox çözümleri.', img: '/images/products/prod-6.webp' },
  { id: 7, slug: 'cephe-lightbox', name: 'Cephe Lightbox Sistemleri', desc: 'Bina ve mağaza cephelerini tamamen kaplayan büyük ölçekli aydınlatmalı cephe sistemleri.', img: '/images/products/prod-7.webp' },
  { id: 8, slug: 'menu-lightbox', name: 'Menü ve Yönlendirme Lightbox Panelleri', desc: 'Restoran, AVM ve kurumsal binalarda kullanılan menü panoları ve yönlendirme sistemleri.', img: '/images/products/prod-8.webp' },
];

const VISIBLE_MD = 4;
const VISIBLE_SM = 2;

export default function Products() {
  const [current, setCurrent] = useState(0);

  // Responsive visible count handled via CSS; slider logic uses md breakpoint (4 visible)
  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(products.length - VISIBLE_MD, c + 1));

  return (
    <section id="products" className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between mb-10 md:mb-12">
          <div>
            <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-3">
              <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
              Ürün Kataloğu
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900">İzmir Lightbox Ürün Çeşitlerimiz</h2>
          </div>
          <div className="hidden md:flex items-center gap-3">
            <button aria-label="Önceki ürün" onClick={prev} disabled={current === 0} className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer">
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button aria-label="Sonraki ürün" onClick={next} disabled={current >= products.length - VISIBLE_MD} className="w-10 h-10 flex items-center justify-center rounded-full bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer">
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        {/* Mobile: 2-column grid, no slider */}
        <div className="grid grid-cols-2 gap-4 md:hidden">
          {products.map((p) => (
            <Link key={p.id} to={`/urunler/${p.slug}`} className="bg-white rounded-2xl overflow-hidden group cursor-pointer active:scale-95 transition-transform duration-200">
              <div className="relative overflow-hidden h-36">
                <img src={p.img} alt={p.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-3">
                <h3 className="font-bold text-gray-900 text-sm mb-1 line-clamp-2">{p.name}</h3>
                <span className="inline-flex items-center gap-1 text-red-600 text-xs font-semibold">
                  İncele <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Desktop: sliding carousel */}
        <div className="hidden md:block overflow-hidden">
          <div
            className="flex gap-6 transition-transform duration-500"
            style={{ transform: `translateX(calc(-${current} * (25% + 6px)))` }}
          >
            {products.map((p) => (
              <Link
                key={p.id}
                to={`/urunler/${p.slug}`}
                className="flex-shrink-0 w-[calc(25%-18px)] bg-white rounded-2xl overflow-hidden group cursor-pointer hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="relative overflow-hidden h-52">
                  <img src={p.img} alt={p.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-gray-900 text-base mb-2">{p.name}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{p.desc}</p>
                  <span className="inline-flex items-center gap-1 text-red-600 text-sm font-semibold group-hover:gap-2 transition-all">
                    Detayları İncele <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Desktop dots */}
        <div className="hidden md:flex justify-center gap-2 mt-6">
          {Array.from({ length: products.length - VISIBLE_MD + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              aria-label={`Ürün ${i + 1}'e git`}
              className="w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <span className={`block rounded-full transition-all ${i === current ? 'w-6 h-2 bg-red-600' : 'w-2 h-2 bg-gray-300'}`} />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
